import RuFlag from 'assets/icons/ru.svg';
import EnFlag from 'assets/icons/en.svg';
import KzFlag from 'assets/icons/kz.svg';
import UzFlag from 'assets/icons/uz.svg';
import { Language } from '@generated/graphql';
import SelectableItem from 'components/SelectableItem';
import { Selectedlanguage } from 'pages/onboarding/LanguageSelect/types';

const LANGUAGE_ITEM = {
  [Language.Ru]: { title: 'Русский', icon: RuFlag },
  [Language.En]: { title: 'English', icon: EnFlag },
  [Language.Kk]: { title: 'Kазақша', icon: KzFlag },
  [Language.Uz]: { title: "O'zbek", icon: UzFlag },
};

interface ILanguageItemProps {
  language: Language;
  selectedLanguage: Selectedlanguage;
  onSelectLanguage: () => void;
}

const LanguageItem = ({ language, selectedLanguage, onSelectLanguage }: ILanguageItemProps) => {
  return (
    <SelectableItem
      title={LANGUAGE_ITEM[language].title}
      icon={LANGUAGE_ITEM[language].icon}
      isSelected={selectedLanguage === language}
      onSelect={onSelectLanguage}
    />
  );
};

export default LanguageItem;
